import { type Gateway as GraftGateway } from '@graft/nuget-gc.webportals.gateways'

import { parseSettingsTimestamp } from '@common/modules/settings/utils/parseSettingsTimestamp'

import { Gateway } from '../types/gateway.type'
import { parseGatewayDateCreated } from '../utils/parseGatewayDateCreated'
import { readGatewayModuleVersionInstanceIds } from '../utils/readGatewayModuleVersionInstanceIds'

import { hostedModuleToObject } from './hosted-module.object'
import { hostedRuntimeToObject } from './hosted-runtime.object'

export async function gatewayToObject(entity: GraftGateway): Promise<Gateway> {
  const [
    id,
    gatewayKey,
    name,
    dateCreatedRaw,
    createdAtRaw,
    updatedAtRaw,
    numberOfCalls,
    status,
    hostedModulesRaw,
    hostedRuntimesRaw,
    lastUsedHostname,
    hostnameRaw,
    gatewayIpRaw,
    isFavourite,
    moduleVersionInstanceIds,
  ] = await Promise.all([
    entity.get_gatewayId(),
    entity.get_gatewayKey(),
    entity.get_name(),
    entity.get_dateCreated(),
    entity.get_createdAt(),
    entity.get_updatedAt(),
    entity.get_numberOfCalls(),
    entity.get_status(),
    entity.get_modules(),
    entity.get_hostedRuntimes(),
    entity.get_lastUsedHostname(),
    entity.get_hostname(),
    entity.get_gatewayIp(),
    entity.get_isFavourite(),
    readGatewayModuleVersionInstanceIds(entity),
  ])

  const [hostedModules, hostedRuntimes] = await Promise.all([
    Promise.all((hostedModulesRaw ?? []).map(hostedModuleToObject)),
    Promise.all((hostedRuntimesRaw ?? []).map(hostedRuntimeToObject)),
  ])

  const hostname = hostnameRaw?.trim() || null
  const gatewayIp = gatewayIpRaw?.trim() || null
  const resolvedLastUsedHostname = lastUsedHostname?.trim() || hostname

  return {
    id,
    gatewayKey,
    name,
    hostedModules,
    hostedRuntimes,
    moduleVersionInstanceIds,
    dateCreated: parseGatewayDateCreated(dateCreatedRaw) ?? parseSettingsTimestamp(createdAtRaw),
    updatedAt: parseSettingsTimestamp(updatedAtRaw),
    numberOfCalls,
    status,
    lastUsedHostname: resolvedLastUsedHostname || null,
    hostname,
    gatewayIp,
    isFavourite: Boolean(isFavourite),
  }
}
